import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from '@standardnotes/utils';
const PreferencesGroup = ({ children, id, className }) => (_jsx("div", { id: id, className: classNames('mb-3 flex max-w-full flex-col rounded border border-solid border-border bg-default p-6', className), children: children }));
export default PreferencesGroup;
